<div class="card">
  <!-- Flagged Session -->
  @if (sessionError) {
    <p class="flagged-session">
      <mat-icon class="xs">flag</mat-icon>
      {{ sessionError.message }}
      @if (sessionError.type === 'template' && permissions.viewSessionTemplates && project?._id) {
        <a href="#/projects/{{ project._id }}/sessionTemplate" test-id="session-data-view-session-template"
          >View Session Template</a
        >
      }
    </p>
  }

  <!-- Data -->
  @if (project?._id) {
    <!-- Make sure we have a project to prevent the regular list from loading before switching to the BIDS list -->
    @if (!projectBids || !(bidsView$ | async)) {
      <acquisition-list class="animated fadeInUp" [collectionId]="collectionId" [session]="session" />
    }
    @if (projectBids && (bidsView$ | async)) {
      <bids-files class="animated fadeInUp" [collectionId]="collectionId" [session]="session" />
    }
  }
</div>
